import Breadcrumbs from '../components/Breadcrumbs.vue'
import Feedback from '../components/Feedback.vue'

const AppComponents = {
    install(Vue) {
        Vue.component('breadcrumbs', Breadcrumbs)
        Vue.component('feedback', Feedback)
    }
}

export default AppComponents
